const carouselItems = [
  {
    image: 'https://readdy.ai/api/search-image?query=Epic%20space%20opera%20cinematic%20scene%20with%20massive%20starship%20fleet%20against%20nebula%20background%2C%20dramatic%20golden%20and%20blue%20cosmic%20lighting%2C%20grand%20scale%20science%20fiction%20composition%2C%20no%20text%20no%20faces&width=1200&height=600&seq=carousel-movie-01&orientation=landscape',
    title: '星际迷航：新纪元',
    tag: '院线同步',
    desc: '人类文明迈向深空的壮丽史诗，年度最受期待的科幻巨制。宏大的宇宙世界观与震撼视觉奇观完美融合。',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Sweeping%20ancient%20Chinese%20landscape%20with%20misty%20mountains%20and%20waterfall%2C%20martial%20arts%20atmosphere%2C%20warm%20sunset%20golden%20light%2C%20epic%20wuxia%20cinematic%20composition%2C%20no%20text%20no%20faces&width=1200&height=600&seq=carousel-movie-02&orientation=landscape',
    title: '夜雨江湖',
    tag: '独家首播',
    desc: '江湖路远，侠义长存。4K修复版重现经典武侠美学，一刀一剑皆是诗，一招一式皆入画。',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Grand%20underwater%20ancient%20civilization%20ruins%20with%20sunbeams%20penetrating%20from%20surface%2C%20mysterious%20atmosphere%2C%20epic%20adventure%20cinematic%20wide%20shot%2C%20teal%20and%20gold%20lighting%2C%20no%20text%20no%20faces&width=1200&height=600&seq=carousel-movie-03&orientation=landscape',
    title: '深海迷城',
    tag: '蓝光首发',
    desc: '潜入万米深渊，揭开失落文明的千年秘密。蓝光原盘画质呈现深海奇观，每一帧都是壁纸级画面。',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Epic%20fantasy%20moonlit%20palace%20floating%20among%20clouds%20with%20cherry%20blossom%20petals%2C%20magical%20atmosphere%2C%20cinematic%20oriental%20fantasy%20composition%2C%20golden%20and%20silver%20ethereal%20lighting%2C%20no%20text%20no%20faces&width=1200&height=600&seq=carousel-movie-04&orientation=landscape',
    title: '月下奇谭',
    tag: '奇幻大片',
    desc: '东方奇幻美学巅峰之作，月色之下人妖殊途的绝美爱恋。视觉效果惊艳，情感层层递进直击人心。',
  },
];

export default function Carousel() {
  return (
    <section id="carousel" className="w-full py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-accent-100 border border-accent-200 mb-4">
            <i className="ri-vip-diamond-line text-accent-600 text-sm"></i>
            <span className="text-xs font-medium text-accent-700 whitespace-nowrap">重磅推荐</span>
          </div>
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-50">
            院线大片
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-200 max-w-lg mx-auto">
            精选院线级大片，每一部都是值得反复品味的佳作
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {carouselItems.map((item, i) => (
            <a
              key={i}
              href="#ranking"
              className="group relative bg-background-100 rounded-3xl overflow-hidden border border-background-200/60 hover:border-primary-500/20 transition-all duration-300 cursor-pointer"
            >
              <div className="relative aspect-[16/9] overflow-hidden">
                <div className="w-full h-full">
                  <img
                    src={item.image}
                    alt={item.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
                  />
                </div>
                <div className="absolute inset-0 bg-gradient-to-t from-background-950/80 via-background-950/20 to-transparent"></div>
                <div className="absolute top-4 left-4">
                  <span className="px-3 py-1.5 text-xs font-semibold rounded-full bg-accent-500 text-foreground-950 whitespace-nowrap">
                    {item.tag}
                  </span>
                </div>
              </div>
              <div className="absolute bottom-0 left-0 right-0 p-5 md:p-6">
                <h3 className="font-heading text-xl md:text-2xl font-bold text-foreground-950 group-hover:text-primary-400 transition-colors mb-2">
                  {item.title}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed line-clamp-2">
                  {item.desc}
                </p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}